import { defineComponent, ref, watch, toRaw } from "vue";

import {
    computeChannelPositionDiff,
    ChannelPositionDiffMap
} from "../domain/channelPositionDiff.js";

import {
    buildChannelSnapshotMap,
    fetchAndOrganizeChannels,
    fetchClusterRange,
    rollbackChannelState,
} from "../adapters/channelPositionAdapter.js";

export default defineComponent({
    props: ["log"],

    setup(props) {
        const diffs = ref<ChannelPositionDiffMap>(new Map());

        watch(
            () => props.log,
            async (log) => {
                const createdAt = toRaw(log).createdAt;

                const [clusterLogs, channelsTree] = await Promise.all([
                    fetchClusterRange((createdAt - 5000), (createdAt + 5000)),
                    fetchAndOrganizeChannels(),
                ]);

                const flatChannels = Array.from(channelsTree.values()).flat();
                const afterMap = buildChannelSnapshotMap(flatChannels);
                const beforeMap = rollbackChannelState(afterMap, clusterLogs);

                diffs.value = computeChannelPositionDiff(beforeMap, afterMap);
            },
            { immediate: true }
        );

        // return () => (
        //     <div class="channel-diff-list">
        //         {diffs.value.length === 0 && (
        //             <div class="empty">Aucun changement détecté</div>
        //         )}

        //         {diffs.value.map((diff) => (
        //             <div class="channel-diff-entry">
        //                 <strong>#{diff.channelName}</strong>

        //                 {diff.type === "move" && (
        //                     <span>
        //                         {" "}
        //                         déplacé ({diff.oldPosition} → {diff.newPosition})
        //                     </span>
        //                 )}

        //                 {diff.type === "category_change" && (
        //                     <span>
        //                         {" "}
        //                         changé de catégorie
        //                     </span>
        //                 )}
        //             </div>
        //         ))}
        //     </div>
        // );
    },
});
